/**
 * ObjectCommandField React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';
import connect from "react-redux/es/connect/connect";

// Material UI
import {withStyles} from "@material-ui/core";

// Material UI components
import FormHelperText from '@material-ui/core/FormHelperText';

// application
import ProgressButton from '../base/ProgressButton';
import {executeObjectCommand} from "../../operations/editing";

/**
 * ObjectCommandField is an editing component for command fields (buttons) of objects
 *
 * @author Maurizio Tidei, Jens Gruschel
 */
export class ObjectCommandField extends React.Component {

    state = {
        busy: false
    }

    render() {

        const { classes, fieldDef } = this.props;

        return <>
            <ProgressButton
                className={classes.button}
                busy={this.state.busy}
                onClick={() => {
                    if (fieldDef.resturl) {
                        this.setState({busy: true});
                        this.props.executeObjectCommand(this.props.objectId,
                            fieldDef.resturl,
                            fieldDef.restmethod ? fieldDef.restmethod : "GET",
                            fieldDef.body,
                            () => this.setState({busy: false}))
                    }
                    else {
                        alert("Please define a resturl field attribute.")
                    }
                }}
            >
                {fieldDef.name}
            </ProgressButton>
            {fieldDef.note && <FormHelperText>{fieldDef.note}</FormHelperText>}
        </>;
    }
}

ObjectCommandField.propTypes = {
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string
};

const styles = {
    button: {
        marginTop: "20px"
    }
};

export default connect(null, {executeObjectCommand})(withStyles(styles)(ObjectCommandField));